import { styled } from '@mui/material';
import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Link as LinkSource, BrowserRouter } from 'react-router-dom';
import {CustomButton} from "../CustomButton";

type Props = {
  to: string;
  variant?: 'text' | 'contained' | 'outlined';
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  forceRefresh?: boolean;
  width?: string | Record<string, any>;
  color?: 'primary' | 'secondary';
};

export const LinkButton: FC<PropsWithChildren<Props>> = ({
  to,
  variant = 'contained',
  startIcon,
  endIcon,
  size,
  children,
  forceRefresh,
  width,
  color = 'primary',
}) => {

  const ButtonRender = (children) => {
    return (
      <Link to={to}>
        <CustomButton
          variant={variant}
          startIcon={startIcon}
          endIcon={endIcon}
          size={size}
          width={width}
          color={color}
        >
          {children}
        </CustomButton>
      </Link>
    );
  }

  if (forceRefresh) {
    return (
      <BrowserRouter forceRefresh>
        {ButtonRender(children)}
      </BrowserRouter>
    );
  }

  return (ButtonRender(children));
};

const Link = styled(LinkSource)(({ theme }) => ({
  textDecoration: 'none',
}));
